const NS = 'CoursesCarouselBlock';
const CLS = 'coursesCarouselBlock';

// core version + navigation modules:
import Swiper, { Navigation } from 'swiper'; // try #1

// Alternate methods to try
// import Swiper bundle with all modules installed
// import Swiper from 'swiper/bundle'; // try #2
// import Swiper from 'swiper/swiper-bundle.esm.browser.min.js'; // try #3
// import Swiper from 'swiper/swiper-bundle.esm.js'; // try #4
// import Swiper from 'swiper/swiper-bundle.js'; // original method

import { animateScrollRevealMixinBlock } from '../../mixins/animateScrollRevealMixinBlock/animateScrollRevealMixinBlock';

export class CoursesCarouselBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$swiper = this.$element.find(`.${CLS}-swiper`);
		this.$buttonNext = this.$element.find(`.${CLS}-swiper-button-next`);
		this.$buttonPrev = this.$element.find(`.${CLS}-swiper-button-prev`);

		try {
			const swiper = new Swiper(this.$swiper[0], {
				speed: 700,
				spaceBetween: 0,
				slidesPerView: 'auto', // scroll 3 at a time instead of 1
				slidesPerGroupAuto: true, // scroll 3 at a time instead of 1
				autoHeight: true,
				modules: [Navigation],
				navigation: {
					nextEl: this.$buttonNext[0],
					prevEl: this.$buttonPrev[0]
				},
				on: {
					init: function() {
						// Bookmarks - this works, but would need to be connected to the bookmarking API at some stage, so hidden for now
						// $(element).find(`.${CLS}-bookmark-btn`).each((index, element) => {
						// 	let $element = $(element);
						// 	$element.on('click', function() {
						// 		if($element.hasClass('selected')) {
						// 			$element.removeClass('selected');
						// 		}
						// 		else {
						// 			$element.addClass('selected');
						// 		}
						// 		return false;
						// 	});
						// });
					}
				}
			});
			console.log('swiper is accessible');
		}
		catch (e) {
			console.log('swiper not accessible');
		}

		this.initAnimateScrollReveal(this, CLS);
	}
}

Object.assign(CoursesCarouselBlock.prototype, animateScrollRevealMixinBlock);
